<template>
  <div class="box-forgot-password-request clearfix">
    <div class="box-title">{{ labels['50'] }}</div>

    <label class="box-input-material position-up clearfix">
      <div class="fa fa-id-card icon-id"></div>
      <input  class="upper" :class="{ 'focus' : forgotIdCardNo != '', 'input-error' : errors.has('idCardNo')}"
              v-model="forgotIdCardNo"
              @keyup.enter="$refs.usernameInput.focus()"
              @keyup="clearResponse()"
              name="idCardNo"
              v-validate="'required'">
      <span>{{ labels['140'] }}</span>
      <div class="login-validate" v-show="errors.has('idCardNo')">{{ errors.first('idCardNo') }}</div>
    </label>

    <label class="box-input-material position-up clearfix">
      <div class="glyphicon glyphicon-user icon-id"></div>
      <input  class="upper" :class="{ 'focus' : forgotUsername != '', 'input-error' : errors.has('username')}"
              v-model="forgotUsername"
              ref="usernameInput"
              @keyup.enter="$refs.emailInput.focus()"
              @keyup="clearResponse()"
              name="username"
              v-validate="'required'">
      <span>{{ labels['20'] }}</span>
      <div class="login-validate" v-show="errors.has('username')">{{ errors.first('username') }}</div>
    </label>

    <label class="box-input-material clearfix">
      <div class="fa fa-envelope icon-id"></div>
      <input  :class="{ 'focus' : forgotEmail != '', 'input-error' : errors.has('email') }"
              type="email"
              v-model="forgotEmail"
              ref="emailInput"
              @keyup.enter="validateInput()"
              @keyup="clearResponse()"
              name="email"
              v-validate="'required|email'">
      <span>{{ labels['70'] }}</span>
      <div class="login-validate" v-show="errors.has('email')">{{ errors.first('email') }}</div>
    </label>

    <div class="infinite-loading-container" v-if="loadingDisp"><i class="loading-wave-dots"></i></div>
    <div class="response-msg" :class="getStatusResponse" v-show="response !== ''">{{ response }}</div>

    <button class="btn-forgot submit" v-on:click="validateInput()" v-show="!dispBtnOk">{{ labels['120'] }}</button>
    <button class="btn-forgot cancel" v-on:click="cancel()" v-show="!dispBtnOk">{{ labels['110'] }}</button>
    <!-- <button class="btn-change submit" v-on:click="cancel()" v-show="dispBtnOk">{{ labels['130'] }}</button> -->
  </div>
</template>

<script>
export default {
  name: 'forgot-password-request',
  data () {
    return {
      forgotIdCardNo: '',
      forgotUsername: '',
      forgotEmail: '',
      dispBtnOk: false
    }
  },
  props: [
    'pcDisp',
    'loadingDisp',
    'goLogin',
    'postForgotPassword',
    'response',
    'setForgotPasswordResponse',
    'inputUsername',
    'labels' ],
  watch: {
    inputUsername () {
      this.forgotUsername = this.inputUsername
    }
  },
  methods: {
    clearResponse () {
      this.isLoading = false
      this.setForgotPasswordResponse('')
    },
    validateInput () {
      this.isLoading = false
      this.setForgotPasswordResponse('')
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isLoading = true
          var formForgotPassword = {
            forg_idcardno: this.forgotIdCardNo,
            forg_username: this.forgotUsername,
            forg_email: this.forgotEmail
          }
          this.postForgotPassword({params: formForgotPassword, clearData: this.clear})
          // this.clear()
          // this.forgotEmail = ''
          // this.forgotIdCardNo = ''
        }
      })
    },
    cancel () {
      this.clear()
      this.goLogin()
    },
    clear () {
      this.forgotUsername = this.inputUsername
      this.forgotEmail = ''
      this.forgotIdCardNo = ''
      this.clearResponse()
      this.errors.clear()
    }
  },
  computed: {
    getStatusResponse () {
      let result
      if (this.response.search('HR2601') !== -1) {
        this.dispBtnOk = true
        result = 'msg-success'
      } else {
        this.dispBtnOk = false
        result = ''
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// forgotPasswordRequest.vue?c1e2c5a8